import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "app/login/login.service";
import { FaturasModel } from "./faturas.model";
import { FaturasService } from "./faturas.service";
import { Form, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BasicValidators } from "../shared/basic-validators";
import { ClientesService } from "../clientes/clientes.service";
import { Observable } from 'rxjs/Rx';

declare let swal, $: any;

@Component({
  selector: 'app-faturas',
  templateUrl: './faturas.component.html'
})
export class FaturasComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "data_vencimento": "", "data_pagamento": "", "cliente": "", "forma_pagamento": "", "valor_total": "", "numero": "", "nota_fiscal": "", "container": "", "ordem_campo": "data", "ordem_direcao": "d" };

  faturas: FaturasModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };
  formSolicitarFatura: FormGroup;
  solicitaFatura = { "id_fatura": null, "email": "" };

  formConfirmarPagamento: FormGroup;
  confirmarPagamento = { "id_fatura": null, "data": null };

  selecionarTodos: boolean = false;
  selecionados: any = {};
  formConfirmarPagamentoEmMassa: FormGroup;
  confirmarPagamentoEmMassaData = { "data": null };

  formInformarNF: FormGroup;
  informarNFData = { "id_fatura": null, "nota_fiscal": null };
  carregandoBotaoNF: boolean = false;

  formAlterarValor: FormGroup;
  alterarValorData = { "id_fatura": null, "valor": "" };
  carregandoBotaoAlterarValor: boolean = false;

  listClientes = [];
  listStatusFatura = [];
  listFormaPagamento = [{
    "texto": "Boleto",
    "valor": "boleto"
  }, {
    "texto": "Débito",
    "valor": "debito"
  }];

  constructor(
    formBuilder: FormBuilder,
    private faturasService: FaturasService,
    private clientesService: ClientesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8) + '01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {

      if (global.debug) {
        console.log('privilegios', data.privilegios);
      }
      for (let i in data.privilegios) {
        if (data.privilegios[i].acao[0].url == 'financeiro') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formSolicitarFatura = formBuilder.group({
      id_fatura: ['', [
        Validators.required
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
    });

    this.formConfirmarPagamento = formBuilder.group({
      id_fatura: ['', [
        Validators.required
      ]],
      data: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
    });

    this.formConfirmarPagamentoEmMassa = formBuilder.group({
      data_pagamento_massa: ['', [
        Validators.required,
        BasicValidators.notNull
      ]]
    });

    this.formInformarNF = formBuilder.group({
      id_fatura: ['', [
        Validators.required
      ]],
      nota_fiscal: ['', [
        Validators.maxLength(10)
      ]]
    });

    this.formAlterarValor = formBuilder.group({
      id_fatura: ['', [
        Validators.required
      ]],
      valor: ['', [
        Validators.required
      ]]
    });

    this.formPesquisaAvancada = formBuilder.group({
      cliente: [],
      responsavel: [],
      cnpj: [],
      tipo_faturamento: [],
      forma_pagamento: [],
      periodo_faturamento: []
    });

    this.listStatusFatura = [{
      "texto": func.traduzir('front.statusFatura0'),
      "valor": "0"
    }, {
      "texto": func.traduzir('front.statusFatura1'),
      "valor": "1"
    }, {
      "texto": func.traduzir('front.statusFatura2'),
      "valor": "2"
    }, {
      "texto": func.traduzir('front.statusFatura3'),
      "valor": "3"
    }, {
      "texto": func.traduzir('front.statusFatura4'),
      "valor": "4"
    }];

    this.formPesquisaAvancada = formBuilder.group({
      status_pesquisa: [],
      data_de: [],
      data_ate: [],
      data_vencimento: [],
      data_pagamento: [],
      cliente: [],
      forma_pagamento: [],
      valor_total: [],
      numero: [],
      nota_fiscal: [],
      container: []
    });

    this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento'])
      .subscribe(
        json => {
          this.listClientes = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = Object.assign(this.filtroPesquisa, filtroSalvo);
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }
    this.getPage(1);
  }

  setOrdem(campo: string) {
    if (this.filtroPesquisa.ordem_campo === campo) {
      this.filtroPesquisa.ordem_direcao = (this.filtroPesquisa.ordem_direcao === 'a') ? 'd' : 'a';
    } else {
      this.filtroPesquisa.ordem_campo = campo;
      this.filtroPesquisa.ordem_direcao = 'a';
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
  }

  delete(fatura) {
    let faturas = this.faturas;
    let faturasService = this.faturasService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFicha') + fatura.id_fatura,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {

        if (self.global.debug == true) {
          console.log(faturas);
        }

        let index = faturas.indexOf(fatura);
        faturas.splice(index, 1);

        faturasService.apagar(fatura.id_fatura)
          .subscribe(res => {
            //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
            self.faturas = faturas;
          },
            err => {
              // Revert the view back to its original state
              faturas.splice(index, 0, fatura);
              self.faturas = faturas;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.selecionarTodos = false;
    this.selecionados = {};

    let filtros = {};

    if (this.filtroPesquisa.status_pesquisa != '') {
      filtros['status'] = this.filtroPesquisa.status_pesquisa;
    } else {
      filtros['status'] = '0|1|2|4';
    }

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data'] = 'ge:' + this.filtroPesquisa.data_de;
      }
      if (this.filtroPesquisa.data_ate) {
        filtros['data'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }


    if (this.filtroPesquisa.data_vencimento != '') {
      filtros['data_vencimento'] = "**:" + this.filtroPesquisa.data_vencimento;
    }

    if (this.filtroPesquisa.data_pagamento != '') {
      filtros['data_pagamento'] = this.filtroPesquisa.data_pagamento;
    }

    if (this.filtroPesquisa.cliente != '') {
      filtros['id_cliente'] = this.filtroPesquisa.cliente;
    }

    if (this.filtroPesquisa.forma_pagamento != '') {
      filtros['forma_pagamento'] = this.filtroPesquisa.forma_pagamento;
    }

    if (this.filtroPesquisa.valor_total != '') {
      filtros['valor_total'] = this.filtroPesquisa.valor_total;
    }

    if (this.filtroPesquisa.numero != '') {
      filtros['numero'] = "**:" + this.filtroPesquisa.numero;
    }

    if (this.filtroPesquisa.nota_fiscal != '') {
      filtros['nota_fiscal'] = "**:" + this.filtroPesquisa.nota_fiscal;
    }

    if (this.filtroPesquisa.container && this.filtroPesquisa.container != '') {
      filtros['container'] = "**:" + this.filtroPesquisa.container;
    }

    let sort = {};
    let campoSort = this.filtroPesquisa.ordem_campo || 'data';
    let direcaoSort = this.filtroPesquisa.ordem_direcao || 'd';
    sort[campoSort] = direcaoSort;

    this.faturasService.getPaginacao(pagina, this.itensPorPagina, ['moeda', 'cliente'], filtros, null, sort)
      .subscribe(data => {
        this.faturas = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.faturas);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  gerarPDF(id) {
    alert('falta fazer');
  }

  alteraStatus(fatura, status, notifica = true) {


    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaAtualizarStatusFatura') + fatura.id_fatura,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {

        self.faturasService.alteraStatus(fatura.id_fatura, status, null, notifica)
          .subscribe(res => {
            self.getPage(self.paginaAtual);
            //swal(self.func.traduzir('front.atualizado'), this.func.traduzir('front.statusAtualizadoSucesso'), "success");
          },
            error => {
              self.func.showErro(error.json());
            });

      });
  }

  modalSolicitaFatura(id) {
    this.solicitaFatura.id_fatura = id;
    $('#modalSolicitarFatura').modal('show');
  }

  solicitaFaturaEmail() {
    this.faturasService.enviaPdfEmail(this.solicitaFatura.id_fatura, this.solicitaFatura)
      .subscribe(json => {
        $('#modalSolicitarFatura').modal('hide');
      },
        error => {
          this.func.showErro(error.json());
        });
  }

  modalConfirmarPagamento(id) {
    this.confirmarPagamento.id_fatura = id;
    $('#modalConfirmaPagamento').modal('show');
  }

  confirmarPagamentoFatura() {

    this.faturasService.alteraStatus(this.confirmarPagamento.id_fatura, 2, this.confirmarPagamento.data)
      .subscribe(res => {
        this.getPage(this.paginaAtual);
        $('#modalConfirmaPagamento').modal('hide');
      },
        error => {
          this.func.showErro(error.json());
        });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "data_vencimento": "", "data_pagamento": "", "cliente": "", "forma_pagamento": "", "valor_total": "", "numero": "", "nota_fiscal": "", "container": "", "ordem_campo": "data", "ordem_direcao": "d" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.faturas.forEach(fatura => {
      this.selecionados[fatura.id_fatura] = this.selecionarTodos;
    });
  }

  marcarItem(fatura, event) {
    this.selecionados[fatura.id_fatura] = event.target.checked;

    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      let todosMarcados = true;
      for (let f of this.faturas) {
        if (!this.selecionados[f.id_fatura]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  private getSelecionadosIds(): string[] {
    let ids = [];
    for (let id in this.selecionados) {
      if (this.selecionados[id]) {
        ids.push(id);
      }
    }
    return ids;
  }

  getStatusTexto(status: any): string {
    const found = this.listStatusFatura.find(s => s.valor == String(status));
    return found ? found.texto : '';
  }

  enviarEmailEmMassa() {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: `Deseja realmente enviar as ${selecionadosIds.length} faturas por e-mail para seus respectivos clientes?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: false,
    },
      function () {
        self.carregandoTabela = true;
        let observables = selecionadosIds.map(id =>
          self.faturasService.enviaPdfEmail(id, { id_fatura: id, email: null })
        );

        Observable.forkJoin(observables).subscribe(
          results => {
            self.carregandoTabela = false;
            swal(self.func.traduzir('front.sucesso'), "Faturas enviadas por e-mail com sucesso.", "success");
            self.selecionados = {};
            self.selecionarTodos = false;
            self.getPage(self.paginaAtual);
          },
          error => {
            self.carregandoTabela = false;
            self.func.showErro(error.json());
          }
        );
      });
  }

  alterarStatusEmMassa(status: any, data_pagamento: string = null, notifica: boolean = true) {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    let statusStr = String(status);
    // Filtrar faturas que podem ser alteradas, ignorando as que já estão no status ou que são canceladas (status 3)
    let faturasParaAlterar = this.faturas.filter(f =>
      selecionadosIds.includes(String(f.id_fatura)) && f.status != statusStr && f.status != '3'
    );

    if (faturasParaAlterar.length == 0) {
      swal(this.func.traduzir('front.atencao'), "Nenhuma das faturas selecionadas pode ser alterada para este status.", "warning");
      return;
    }

    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: `Deseja realmente alterar o status de ${faturasParaAlterar.length} faturas para ${this.getStatusTexto(status)}?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: false,
    },
      function () {
        self.carregandoTabela = true;
        let observables = faturasParaAlterar.map(f =>
          self.faturasService.alteraStatus(f.id_fatura, status, data_pagamento, notifica)
        );

        Observable.forkJoin(observables).subscribe(
          results => {
            self.carregandoTabela = false;
            swal(self.func.traduzir('front.sucesso'), "Status das faturas alterados com sucesso.", "success");
            self.selecionados = {};
            self.selecionarTodos = false;
            self.getPage(self.paginaAtual);
          },
          error => {
            self.carregandoTabela = false;
            self.func.showErro(error.json());
          }
        );
      });
  }

  alterarStatusPagoEmMassa() {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    let faturasParaAlterar = this.faturas.filter(f =>
      selecionadosIds.includes(String(f.id_fatura)) && f.status != '2' && f.status != '3'
    );

    if (faturasParaAlterar.length == 0) {
      swal(this.func.traduzir('front.atencao'), "Nenhuma das faturas selecionadas pode ser alterada para Pago.", "warning");
      return;
    }

    this.confirmarPagamentoEmMassaData.data = new Date().toISOString().substr(0, 10);
    $('#modalConfirmaPagamentoEmMassa').modal('show');
  }

  confirmarPagamentoFaturaEmMassa() {
    let selecionadosIds = this.getSelecionadosIds();
    let faturasParaAlterar = this.faturas.filter(f =>
      selecionadosIds.includes(String(f.id_fatura)) && f.status != '2' && f.status != '3'
    );

    $('#modalConfirmaPagamentoEmMassa').modal('hide');
    this.carregandoTabela = true;

    let observables = faturasParaAlterar.map(f =>
      this.faturasService.alteraStatus(f.id_fatura, 2, this.confirmarPagamentoEmMassaData.data)
    );

    Observable.forkJoin(observables).subscribe(
      results => {
        this.carregandoTabela = false;
        swal(this.func.traduzir('front.sucesso'), "Status das faturas alterados para Pago com sucesso.", "success");
        this.selecionados = {};
        this.selecionarTodos = false;
        this.getPage(this.paginaAtual);
      },
      error => {
        this.carregandoTabela = false;
        this.func.showErro(error.json());
      }
    );
  }

  modalInformarNF(fatura) {
    this.carregandoBotaoNF = false;
    this.informarNFData.id_fatura = fatura.id_fatura;
    this.informarNFData.nota_fiscal = fatura.nota_fiscal;
    $('#modalInformarNF').modal('show');
  }

  salvarNotaFiscal() {
    this.carregandoTabela = true;
    this.carregandoBotaoNF = true;
    this.faturasService.getById(this.informarNFData.id_fatura, ['itens'])
      .subscribe(json => {
        let fatura = json.Payload[0];
        fatura.nota_fiscal = this.informarNFData.nota_fiscal;
        
        this.faturasService.editar(fatura, fatura.id_fatura)
          .subscribe(res => {
            this.carregandoBotaoNF = false;
            $('#modalInformarNF').modal('hide');
            swal(this.func.traduzir('front.sucesso'), this.func.traduzir('back.operacaoRealizadaSucesso'), "success");
            this.getPage(this.paginaAtual);
          }, error => {
            this.carregandoTabela = false;
            this.carregandoBotaoNF = false;
            this.func.showErro(error.json());
          });
      }, error => {
        this.carregandoTabela = false;
        this.carregandoBotaoNF = false;
        this.func.showErro(error.json());
      });
  }

  modalAlterarValor(fatura) {
    this.carregandoBotaoAlterarValor = false;
    this.alterarValorData.id_fatura = fatura.id_fatura;
    this.alterarValorData.valor = fatura.valor_total;
    this.formAlterarValor.patchValue({
      id_fatura: fatura.id_fatura,
      valor: fatura.valor_total
    });
    $('#modalAlterarValor').modal('show');
  }

  salvarAlterarValor() {
    this.carregandoTabela = true;
    this.carregandoBotaoAlterarValor = true;
    this.faturasService.alterarValorFixo(this.alterarValorData.id_fatura, this.alterarValorData.valor)
      .subscribe(res => {
        this.carregandoBotaoAlterarValor = false;
        $('#modalAlterarValor').modal('hide');
        swal(this.func.traduzir('front.sucesso'), this.func.traduzir('back.operacaoRealizadaSucesso'), "success");
        this.getPage(this.paginaAtual);
      }, error => {
        this.carregandoTabela = false;
        this.carregandoBotaoAlterarValor = false;
        this.func.showErro(error.json());
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/faturas/faturas.component.ts